<template>
  <div class="view-container text-center">
    <h3>Please select your nearest branch</h3>
    <form name="BranchSelectContainer">
        <!-- @foreach (var branch in Model)
        { -->
        <div v-for="branch in branches" :key="branch.id" name="BranchContainer" :data-id="branch.id">
            <iframe frameborder="0" style="border:0" :src="branch.mapURL" allowfullscreen></iframe>
            <h3>{{branch.name}}</h3>
            <div class="form-group branch-contact">
                <label>Contact no:</label>
                <label class="contact">{{branch.contactNo}}</label>
            </div>
            <div class="form-group branch-email">
                <label>Email address:</label>
                <label class="email">{{branch.emailAddress}}</label>
            </div>
            <div class="form-group branch-select">
                <button class="btn btn-primary" :style="{ 'background-color': accentColor }">Select</button>
            </div>
        </div>
        <!-- } -->
    </form>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Branch.vue.js";

export default {
  name: "Branch",
  components: {
  },
  mixins: [view],
  data() {
    return {
      branches: []
    }
  },
  computed: {
      accentColor: function () {
        return this.$franchiseAccentColor;
      }
  },
  mounted() {
    var _self = this;

    this.$ooApi.orders.branches.v1({franchiseID: localStorage.franchiseID})
    .then(function (result) {
      _self.branches = result.data;
    })
    .then(function () {
      document.querySelectorAll('form[name=BranchSelectContainer] div[name=BranchContainer]').forEach(item => {
      item.addEventListener("click", _self.selectBranch);
      });
    });
  },
};
</script>
<style>
    @import './Branch.vue.css'; 
</style>
